import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  EllipsisVerticalIcon,
} from '@fukuri-admins/ui/common';
import { iconButtonVariants } from '@fukuri-admins/ui/common/IconButton/logic';
import styles from './styles.module.scss';

type Props = {
  isActive: boolean;
  onSelectEdit: () => void;
  onSelectToggleStatus: () => void;
  onSelectDelete: () => void;
};

/**
 * トップバナードロップダウンメニューのプレゼンテーションコンポーネント
 */
export const TopBannerDropdownMenuPresentation: React.FC<Props> = ({
  isActive,
  onSelectEdit,
  onSelectToggleStatus,
  onSelectDelete,
}) => (
  <DropdownMenu>
    <DropdownMenuTrigger>
      <button type='button' className={iconButtonVariants({ variant: 'ghost', size: 'md' })}>
        <EllipsisVerticalIcon size='xs' />
      </button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align='end'>
      <DropdownMenuItem onSelect={onSelectEdit}>編集</DropdownMenuItem>
      <DropdownMenuItem onSelect={onSelectToggleStatus}>
        {isActive ? '非表示にする' : '表示する'}
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem className={styles.deleteMenuItem} onSelect={onSelectDelete}>
        削除
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
